<div
    #parentElement
    class="graph-container"
    (click)="addRipple($event)"
    [ngStyle]="{
        'min-height': graphMinHeight ? graphMinHeight : '100%',
        'min-width': graphMinHeight ? 'calc(100% + 25px)' : '100%',
    }"
>
    <div
        data-cy="trend-graph-preview"
        #graphContainer
        class="graph"
        (mousemove)="updateVerticalPointerAlignment($event)"
        (mouseleave)="updateVerticalPointerAlignment()"
    ></div>

    <div
        data-cy="trend-graph-crosshair-horizontal-line"
        class="rangefinder-line rangefinder-line-horizontal"
        [ngStyle]="horizontalRangefinderStyle"
    ></div>
    <div
        data-cy="trend-graph-crosshair-vertical-line"
        class="rangefinder-line rangefinder-line-vertical"
        [ngStyle]="verticalRangefinderStyle"
    ></div>
    <div
        data-cy="trend-graph-crosshair-center"
        #pointer
        class="rangefinder-pointer"
        [ngStyle]="pointerStyle"
    ></div>

    <div #tooltip class="tooltip-container" [ngStyle]="tooltipStyle">
        <div>
            <div class="tooltip-value">
                <div data-cy="trend-graph-tooltip-date">
                    {{
                        tooltipDate.getFullYear() +
                            "-" +
                            (tooltipDate.getMonth() + 1) +
                            "-" +
                            tooltipDate.getDate()
                    }}
                </div>
                <div data-cy="trend-graph-tooltip-time">
                    {{ formatTime(tooltipDate) }}
                </div>
            </div>
            <div
                *ngFor="let data of tooltipData"
                class="tooltip-value"
                [ngStyle]="{ color: data.color }"
            >
                <div data-cy="trend-graph-tooltip-channel-name">
                    {{ data.label }}
                </div>
                <div data-cy="trend-graph-tooltip-channel-value">
                    {{ data.value }} {{ data.unit }}
                </div>
            </div>
        </div>
    </div>
</div>
